import * as React from "react";
import { useEffect } from "react";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import { injectIntl, useIntl } from "react-intl";
import { DateFilter } from '../DateFilter';
import { Loader } from '../Loader';
import { TranslateText } from '../TranslateText';
import { TableWidget } from "../TableWidget";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export let SortByType = /*#__PURE__*/function (SortByType) {
  SortByType["Asc"] = "asc";
  SortByType["Desc"] = "desc";
  return SortByType;
}({});

// chart
const PieChart = props => {
  const randomID = (Math.random() + 1).toString(36).substring(7);
  const intl = useIntl();
  useEffect(() => {
    const pie_chart = am4core.create(randomID, am4charts.PieChart);
    pie_chart.data = props.value;
    if (pie_chart.logo) {
      pie_chart.logo.disabled = true;
    }
    // Set inner radius
    pie_chart.innerRadius = am4core.percent(30);

    // Add and configure series
    let pieSeries = {};
    pieSeries = pie_chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "counts";
    pieSeries.dataFields.category = "productID";
    pieSeries.labels.template.disabled = true;
    pieSeries.ticks.template.disabled = true;
    pieSeries.slices.template.stroke = am4core.color("#000000");
    pieSeries.slices.template.strokeWidth = 1;
    pieSeries.slices.template.strokeOpacity = 1;
    pieSeries.slices.template.propertyFields.fill = "color";

    // This creates initial animation
    pieSeries.hiddenState.properties.opacity = 1;
    pieSeries.hiddenState.properties.endAngle = -90;
    pieSeries.hiddenState.properties.startAngle = -90;

    // Pie Series Tooltip Test and bg color
    pieSeries.tooltip.getFillFromObject = false;
    pieSeries.tooltip.background.fill = am4core.color("#FFFFFF");
    pieSeries.tooltip.label.fill = am4core.color("#000000");

    // Cleanup function when component unmounts
    return () => {
      pie_chart.dispose();
    };
  }, [props.information, props.brandID]);
  return /*#__PURE__*/_jsx("div", {
    className: "kc-ui-pie-chart",
    id: randomID
  });
};
const TotalCount = props => {
  let totalCount = props?.value.reduce((acc, item) => acc + item.counts, 0) || null;
  return /*#__PURE__*/_jsx("div", {
    style: {
      textAlign: 'center',
      padding: 10
    },
    children: totalCount > 0 ? /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: totalCount
      }), /*#__PURE__*/_jsx(TranslateText, {
        id: props.totalCountText
      })]
    }) : null
  });
};
const _PieChartTable = props => {
  const {
    loader,
    title,
    width,
    dateFilterTitle,
    dateFilter,
    dateFilterOptions,
    dateFilterValue,
    onTriggerDateFilterChange,
    dateFilterDateFormat,
    disabled,
    totalCountText
  } = props;
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: `kc-ui-colm kc-ui-piechart ${disabled && "kc-ui-disabled "}  ${loader && "kc-ui-loader-overlay"}`,
      style: {
        width: `${width}`
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "kc-ui-colm-div kc-ui-piechart",
        children: [title ? /*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(TranslateText, {
            id: title
          })
        }) : null, /*#__PURE__*/_jsx("div", {
          className: "kc-ui-datefilter-div",
          children: dateFilter && /*#__PURE__*/_jsx(DateFilter, {
            title: dateFilterTitle,
            options: dateFilterOptions,
            value: dateFilterValue,
            onTriggerChange: onTriggerDateFilterChange,
            dateFormat: dateFilterDateFormat
          })
        }), loader ? /*#__PURE__*/_jsx(Loader, {
          loader: loader
        }) : /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "kc-ui-pie-chart-wrapper",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "kc-ui-pie-chart-div",
              children: [/*#__PURE__*/_jsx(PieChart, {
                ...props
              }), totalCountText ? TotalCount(props) : null]
            }), /*#__PURE__*/_jsx("div", {
              className: "kc-ui-pie-chart-table-div",
              children: /*#__PURE__*/_jsx(TableWidget, {
                column: props.column,
                value: props.value,
                noValueText: props.noValueText,
                loader: false,
                title: '',
                width: '100%',
                disabled: false,
                search: false,
                searchPlaceholder: ``,
                onTriggerColumnClick: e => console.log(e),
                onTriggerCheckboxChange: e => console.log(e),
                filter: false,
                filterOptions: [],
                onTriggerFilterChange: () => {},
                toolbarControls: [],
                onTriggerToolbarControlClick: () => {},
                dateFilterTitle: '',
                dateFilter: false,
                dateFilterOptions: [],
                defaultSort: {
                  key: '',
                  sortBy: SortByType.Asc
                },
                dateFilterValue: dateFilterValue,
                onTriggerDateFilterChange: () => {},
                dateFilterDateFormat: '',
                pagination: false,
                pageSize: 10,
                totalRecords: 0,
                pageNumber: 1,
                onTriggerPaginationChange: () => {},
                showHintMessage: false,
                hintMessage: ""
              })
            })]
          })
        })]
      })
    })
  });
};
_PieChartTable.defaultProps = {
  loader: false,
  dateFilterTitle: '',
  dateFilter: false,
  dateFilterOptions: [],
  onTriggerDateFilterChange: () => {},
  dateFilterValue: {},
  dateFilterDateFormat: "MM/dd/yyyy",
  width: "100%",
  disabled: false,
  information: [],
  brandID: "",
  title: "",
  column: [],
  value: [],
  defaultSort: {
    key: '',
    sortBy: ''
  },
  noValueText: "",
  totalCountText: ""
};
export const PieChartTableWidget = injectIntl( /*#__PURE__*/React.memo(_PieChartTable));